import { type PlatformType } from '@alfa-bank/newclick-types';
import { useHydrateAtoms } from 'jotai/utils';

import { appConfigAtom } from '../../atoms/app-config/atom';
import { moneyPoolInitialAtom } from '../../atoms/money-pool-data/atom';
import { platformAtom } from '../../atoms/platform/atom';
import { type MoneyPoolData } from '../../types';
import { type ConfigType } from '../../types/config';

type Props = {
    platform: PlatformType;
    appConfig: ConfigType;
    moneyPoolInitial?: MoneyPoolData;
};

export const HydrateInitialAtoms = ({ platform, appConfig, moneyPoolInitial }: Props) => {
    useHydrateAtoms([
        [platformAtom, platform],
        [appConfigAtom, appConfig],
        [moneyPoolInitialAtom, moneyPoolInitial],
    ]);

    return null;
};
